import React from "react";
import "./RainBackground.css";

const DROPS = Array.from({ length: 60 }, (_, i) => i);

export default function RainBackground() {
  return (
    <div className="rain-bg">
      {DROPS.map((i) => (
        <div
          key={i}
          className="rain-drop"
          style={{
            left: `${(i / 60) * 100}%`,
            animationDelay: `${(i * 0.17) % 3}s`,
            animationDuration: `${1.2 + (i % 5) * 0.3}s`,
            opacity: 0.15 + (i % 4) * 0.08,
          }}
        />
      ))}
    </div>
  );
}
